/**
 * ERPShared.jsx — Tiny shared display components used by multiple ERP tabs.
 * StatCard  — metric tile with accent border
 * EditCell  — click-to-edit inline cell
 */
import React, { useState } from 'react';
import { Pencil, Check, X } from 'lucide-react';

export function StatCard({ label, value, color = '#3b82f6', icon: Icon }) {
  return (
    <div style={{
      flex: '1 1 140px', minWidth: 120, padding: '12px 16px',
      background: 'var(--surface-2,#f8fafc)', borderRadius: 10,
      border: '1px solid var(--border,#e2e8f0)',
      borderLeft: `3px solid ${color}`,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
        {Icon && <Icon size={13} color={color} />}
        <span style={{ fontSize: '0.71rem', color: 'var(--text-muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.04em' }}>{label}</span>
      </div>
      <div style={{ fontSize: '1.55rem', fontWeight: 700, color }}>{value ?? '—'}</div>
    </div>
  );
}

export function EditCell({ value, onSave, width = 140, placeholder = '—' }) {
  const [editing, setEditing] = useState(false);
  const [val, setVal]         = useState(value || '');
  const commit = () => { onSave(val); setEditing(false); };
  if (editing) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
        <input
          autoFocus value={val}
          onChange={e => setVal(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') commit(); if (e.key === 'Escape') setEditing(false); }}
          style={{ width, fontSize: '0.78rem', padding: '2px 6px', border: '1px solid var(--erp-primary,#3b82f6)', borderRadius: 4 }}
        />
        <button onClick={commit} title="Save" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#22c55e', padding: 0 }}><Check size={13} /></button>
        <button onClick={() => setEditing(false)} title="Cancel" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', padding: 0 }}><X size={13} /></button>
      </span>
    );
  }
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, cursor: 'pointer', color: value ? 'inherit' : 'var(--text-muted)' }}
      onClick={() => { setVal(value || ''); setEditing(true); }}>
      <span style={{ fontFamily: value ? 'monospace' : 'inherit', fontSize: '0.78rem' }}>{value || placeholder}</span>
      <Pencil size={10} color="var(--text-muted)" />
    </span>
  );
}
